import api from "@/services/api"
import type { Category } from "../sharedTypes/categories"

export const retrieveCategory = async (
  categoryId: string
): Promise<Category> => {
  const response = await api.get<Category>(
    `/products/categories/${categoryId}`
  )
  return response.body
}
